import * as React from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIIcon from 'UIComponents/icon/UIIcon';
import WebhookPropertyMappingVisualization from 'automation-ui-enrollment/components/eventEnrollment/steps/WebhookPropertyMappingVisualization';

// Needed to increase the specificity of this selector in order to override the private styles
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledAlert = styled(UIAlert).withConfig({
  displayName: "ExamplePropertyMatchingInfoAlert__StyledAlert",
  componentId: "sc-1fee1f1-0"
})(["&&& .white-background-override{background-color:white !important;}"]);
const ExamplePropertyMatchingInfoAlert = () => {
  return /*#__PURE__*/_jsxs(StyledAlert, {
    titleText: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "pin"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.associatingObject.propertyMatching.infoAlert.title"
      })]
    }),
    type: "info",
    children: [/*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.associatingObject.propertyMatching.infoAlert.description"
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(WebhookPropertyMappingVisualization, {
      sourceLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.associatingObject.propertyMatching.source.label"
      }),
      sourceSelectProps: {
        className: 'white-background-override',
        readOnly: true,
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.associatingObject.propertyMatching.infoAlert.sourcePlaceholder"
        })
      },
      destinationLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.associatingObject.propertyMatching.destination.label"
      }),
      destinationSelectProps: {
        className: 'white-background-override',
        readOnly: true,
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.associatingObject.propertyMatching.infoAlert.destinationPlaceholder"
        })
      }
    })]
  });
};
export default ExamplePropertyMatchingInfoAlert;